import { createFileRoute } from '@tanstack/react-router'
import { LeasesPage } from '../../../components/LeasesPage'

export type LeaseStatusFilter = 'running' | 'draft' | 'all'

/** The lease list (spec 2026-10-25-03). Every filter lives in the URL, so the steering console can link to a perimeter. */
export const Route = createFileRoute('/$org/leases/')({
  component: LeasesPage,
  validateSearch: (search: Record<string, unknown>) => ({
    under: search.under ? String(search.under) : undefined,
    regime: search.regime ? String(search.regime) : undefined,
    ends_before: search.ends_before ? String(search.ends_before) : undefined,
    status: (['running', 'draft', 'all'] as const).find((s) => s === search.status) as LeaseStatusFilter | undefined,
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
  }),
})
